export default "__VITE_ASSET__6f4fa4e5__"